import { render, staticRenderFns } from "./judcz_config.vue?vue&type=template&id=4bbb8a03&scoped=true"
import script from "./judcz_config.vue?vue&type=script&lang=js"
export * from "./judcz_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbb8a03",
  null
  
)

export default component.exports